//export const API_ROOT = 'https://one-api.vacway.es/v1/'
export const API_ROOT = 'https://one-api-erp.vacway.es/v1/'
export const GMAPS_KEY = 'AIzaSyB50fu9J8shwHYglxAjacSUreJkK9DWr2c'
// Google OAuth 2.0 Client ID (same one the API validates as audience).
// Leave empty to hide the "Sign in with Google" button.
export const GOOGLE_CLIENT_ID = '761292062701-h4us0q7qsgnfd96lpaqmmfjubkmo5t69.apps.googleusercontent.com'
// Microsoft Entra ID Application (client) ID (same one the API validates).
// Leave empty to hide the "Sign in with Microsoft" button.
export const MICROSOFT_CLIENT_ID = '8d47a463-91b9-4c8c-b711-0dc9f1c17f3e'
